<template>
	<div id="login">
		<h1><i class="el-icon-setting"></i>后台管理系统</h1>
		<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" label-position="top" class="demo-ruleForm">
			<el-form-item label="账号" prop="user">
				<el-input type="text" v-model="ruleForm.user" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="pass">
				<el-input type="password" v-model="ruleForm.pass" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="success" plain round @click="submitForm('ruleForm')">登 录</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#login {
		width: 450px;
		height: 100%;
		padding: 150px 50px 0 50px;
		border-left: 1px solid #67c23a;
		border-right: 1px solid #67c23a;
		margin: auto;
		box-sizing: border-box
	}

	#login button {
		width: 100%;
		margin-top: 10px;
	}

	#login h1 {
		text-align: center;
		color: #67c23a;
	}
</style>

<script>
	export default {
		data() {
			return {
				ruleForm: {
					user: "",
					pass: ""
				},
				rules: {
					user: [{
						required: true,
						message: "请输入账号",
						trigger: "blur"
					}],
					pass: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}]
				}
			};
		},
		methods: {
			submitForm(formName) {
				var self = this;
				//console.log(self.ruleForm);
				self.$refs[formName].validate(valid => {
					if(valid) {
						self.axios.post("https://soren.guanqimiao.cn/Admin/adminLogin?username=" + self.ruleForm.user + "&password=" + self.ruleForm.pass)
							.then(function(response) {
								if(response.data.code == '600') {
									self.$message({
										message: response.data.msg,
										type: 'success'
									});
									localStorage.setItem('mark', response.data.data.mark);
                  localStorage.setItem('roleId', response.data.data.roleId);
									if(response.data.data.roleId == 3){
                      self.$router.push({
                          path: '/stayWord'
                      })
                  }else{
                      self.$router.push({
                          path: '/Product'
                      })
                  }
								} else {
									self.$message({
										message: response.data.msg,
										type: 'error'
									});
								}
								//console.log(response);
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			}
		}
	};
</script>

// WEBPACK FOOTER // // src/components/login.vue



// WEBPACK FOOTER //
// src/components/login.vue